// src/main.jsx
console.log("POHREBKA BUILD", new Date().toISOString(), "BUILD_TS", import.meta.env.VITE_BUILD_TS);
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

// Pokud máš CSS:
import "./index.css";

// Kontext provider:
import { FormDataProvider } from "./context/FormDataContext";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <FormDataProvider>
      <App />
    </FormDataProvider>
  </React.StrictMode>
);
